import { useCallback, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useInfiniteScrollNew } from '../../../shared/hooks/useInfinityScrollNew';
import { loadMoreNotification } from '../../../store/slices/notificationSlice/action';
import { notificationSelector } from '../../../store/slices/notificationSlice/notificationSlice';

export const useNotificationBody = () => {
    const dispatch = useDispatch();

    const notificationsIds = useSelector(notificationSelector.selectIds);
    // @ts-ignore
    const { isLastPage } = useSelector((state) => state.notificationReducer);

    const containerRef = useRef<HTMLDivElement | null>(null);

    const onLoadNextPart = useCallback(() => {
        dispatch(loadMoreNotification());
    }, [dispatch]);

    const lastElementRef = useInfiniteScrollNew(onLoadNextPart, {
        rootRef: containerRef,
        rootMargin: '0px 0px 16px 0px',
        threshold: 0,
    });

    return { containerRef, notificationsIds, lastElementRef, isLastPage };
};
